const initMap = async () => {
  // Import Google Libraries once
  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

    const mapElement = document.getElementById("map");
    if (!mapElement) return;

    const lat = mapElement.getAttribute("data-lat");
    const lng = mapElement.getAttribute("data-lng");
    const mapId = mapElement.getAttribute("data-map-id");
    const zoom = mapElement.getAttribute("data-zoom") || 9;

    if (!lat || !lng || !mapId) return;

    const geocoder = new google.maps.Geocoder();
    const centerPosition = { lat: parseFloat(lat), lng: parseFloat(lng) };

    // Create Map
    const map = new Map(mapElement, {
      center: centerPosition,
      zoom: parseFloat(zoom),
      mapTypeControl: false,
      mapId: mapId,
    });

    const infoWindow = new InfoWindow();

    // Create Center Pin
    new AdvancedMarkerElement({
      position: centerPosition,
      map,
      title: "Center",
    });

    // Other Pins
    // const pins = blockMap.querySelectorAll(".block-map__item");
    // if (pins.length === 0) return;

    // for (const [i, pinData] of [...pins].entries()) {
    //   const position = {
    //     lat: parseFloat(pinData.getAttribute("data-lat")),
    //     lng: parseFloat(pinData.getAttribute("data-lng")),
    //   };

    //   const title = pinData.querySelector(".block-map__item__title")?.innerHTML || "";
    //   const text = pinData.querySelector(".block-map__item__text")?.innerHTML || "";

    //   // const pin = new PinElement({
    //   //   glyph: `${i + 1}`,
    //   //   scale: 1,
    //   // });

    //   const marker = new AdvancedMarkerElement({
    //     position,
    //     map,
    //     title,
    //     // content: pin.element,
    //     gmpClickable: true,
    //   });

    //   try {
    //     const address = await getAddress(position, geocoder);
    //     marker.addListener("click", ({ domEvent }) => {
    //       infoWindow.close();
    //       infoWindow.setContent(`
    //         <div class="info-window">
    //           <header>
    //             <h3>${title}</h3>
    //             <p>${address}</p>
    //           </header>
    //           <main>
    //             ${text}
    //           </main>
    //           <footer>
    //             <a href="https://www.google.com/maps/search/?api=1&query=${position.lat},${position.lng}" target="_blank">
    //               View on Google Maps
    //             </a>
    //           </footer>
    //         </div>
    //       `);
    //       infoWindow.open(marker.map, marker);
    //     });
    //   } catch (error) {
    //     console.error(`Error getting address for marker ${i + 1}: ${error}`);
    //   }
    // }
  
};

export default initMap;

/**
 * Function to reverse geocode and get address
 *
 * @param {*} latLng
 * @param {*} geocoder
 * @returns {Promise<string>}
 */

const getAddress = async (latLng, geocoder) => {
  return new Promise((resolve) => {
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
        resolve(results[0].formatted_address);
      } else {
        resolve("Address not found");
      }
    });
  });
};

